module.exports = __webpack_public_path__ + "fcc-static/media/Roboto-Regular.8a36205bd9b83e03af0591a004bc97f4.ttf";